import React from 'react';
import { Bell, BellOff, Loader2 } from 'lucide-react';
import { usePushNotifications } from '../../hooks/usePushNotifications';
import { APP_NAME } from '../../lib/brand';

const statusCopy = (permission, subscribed) => {
  if (permission === 'denied') return 'Bloccate nelle impostazioni del browser';
  if (subscribed) return "Ricevi un avviso quando l'app è chiusa";
  return "Attiva per ricevere avvisi anche ad app chiusa";
};

const PushToggle = () => {
  const {
    supported, permission, isSubscribed, loading, error,
    subscribe, unsubscribe,
  } = usePushNotifications();

  if (!supported) return null;

  return (
    <div className="px-4 py-3 border-b border-zinc-100 bg-zinc-50/50">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[13px] font-medium text-zinc-900 leading-tight">Notifiche push</p>
          <p className="text-[11px] text-zinc-500 mt-0.5 leading-tight">
            {statusCopy(permission, isSubscribed)}
          </p>
        </div>
        <button
          type="button"
          disabled={loading || permission === 'denied'}
          onClick={() => (isSubscribed ? unsubscribe() : subscribe())}
          className={`flex-shrink-0 inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-[12px] font-medium transition-colors ${
            isSubscribed
              ? 'bg-zinc-100 hover:bg-zinc-200 text-zinc-700'
              : 'bg-[#D4AF37] hover:bg-[#B8941F] text-white'
          } disabled:opacity-50 disabled:cursor-not-allowed`}
          data-testid="push-toggle-btn"
        >
          {loading ? (
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
          ) : isSubscribed ? (
            <><BellOff className="w-3.5 h-3.5" /> Disattiva</>
          ) : (
            <><Bell className="w-3.5 h-3.5" /> Attiva</>
          )}
        </button>
      </div>
      {isSubscribed && /iPad|iPhone|iPod/.test(navigator.userAgent) && (
        <p className="mt-2 text-[10px] text-zinc-500 leading-snug">
          Su iPhone, per leggere titolo e testo a schermo spento: Impostazioni → Notifiche → {APP_NAME} → Anteprime «Sempre».
        </p>
      )}
      {error && (
        <p
          className="mt-2 text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-2 py-1.5 leading-snug"
          data-testid="push-error-msg"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default PushToggle;
